<template>
    <article class="post-item clickable" @click="$router.push({ name: 'post', params: { id: post.id } })">
        <div class="post-item-img" :style="{ 'background-image': 'url(' + post.image.sizes.medium.full_url + ')' }"></div>
        <div class="post-item-content">
            <header class="header">
                <h4 class="post-item-title">{{ post.title }}</h4>
                <time class="post-item-date" pubdate :datetime="post.created_at">{{ post.created_at | moment("DD/MM/YYYY") }}</time>
            </header>
            <p class="post-item-excerpt">{{ post.description }}</p>
        </div>
    </article>
</template>

<script>
    export default {
        props: {
            post: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">
    .post-item {
        display: flex;
        background-color: #ffffff;
        border-radius: 14px;
        overflow: hidden;
        align-items: stretch;
        min-width: 280px;

        .post-item-img {
            width: 140px;
            flex-shrink: 0;
            background-size: cover;
            background-position: center center;
        }

        .post-item-content {
            padding: 14px;
            flex-grow: 1;
        }

        .post-item-date {
            font-size: 11px;
            color: #969696;
        }

        .post-item-title {
            font-size: 18px;
            color: #414242;
            margin: 0;
        }

        .post-item-excerpt {
            font-size: 14px;
            margin: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/posts/PostItem.vue